// extracted by mini-css-extract-plugin
module.exports = {"freeSpins":"_I3uZEUO","moreInfoBtn":"_2z3JR69","centered":"_fgpSSPH"};